var map = {
	"./american-bank.png": "2dd5",
	"./amex.png": "cfb7",
	"./bank-account.png": "ce2f",
	"./mastercard.png": "940f",
	"./unionpay.png": "74e8",
	"./visa.png": "b027"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d2c7";